import { CalendarEditIcon } from './CalendarEditIcon';

/**
 * author: Michael Richins
 * id 2976EA1B-60A3-46FB-97E2-95BB74B0DD22
 * name calendar-edit
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-edit.svg
 * tags
 * - Date / Time 
 * - Edit / Modify 
 */
export const EventEditIcon = CalendarEditIcon;
export default EventEditIcon